<script>
// One icon per file: the package entry re-exports every Lucide icon, which webpack would parse on each build
import ArrowLeftRight from 'lucide-vue/dist/esm/icons/arrow-left-right'
import Check from 'lucide-vue/dist/esm/icons/check'
import ChevronDown from 'lucide-vue/dist/esm/icons/chevron-down'
import CircleAlert from 'lucide-vue/dist/esm/icons/circle-alert'
import CircleCheck from 'lucide-vue/dist/esm/icons/circle-check'
import Copy from 'lucide-vue/dist/esm/icons/copy'
import Cpu from 'lucide-vue/dist/esm/icons/cpu'
import ExternalLink from 'lucide-vue/dist/esm/icons/external-link'
import Info from 'lucide-vue/dist/esm/icons/info'
import Keyboard from 'lucide-vue/dist/esm/icons/keyboard'
import List from 'lucide-vue/dist/esm/icons/list'
import LogOut from 'lucide-vue/dist/esm/icons/log-out'
import Moon from 'lucide-vue/dist/esm/icons/moon'
import TriangleAlert from 'lucide-vue/dist/esm/icons/triangle-alert'
import X from 'lucide-vue/dist/esm/icons/x'

export const SHELL_ICONS = {
  'arrow-left-right': ArrowLeftRight,
  check: Check,
  'chevron-down': ChevronDown,
  'circle-alert': CircleAlert,
  'circle-check': CircleCheck,
  copy: Copy,
  cpu: Cpu,
  'external-link': ExternalLink,
  info: Info,
  keyboard: Keyboard,
  list: List,
  'log-out': LogOut,
  moon: Moon,
  'triangle-alert': TriangleAlert,
  x: X
}

// A header or menu icon in the text color. Attributes such as data-testid land on the svg.
export default {
  name: 'app-shell-icon',

  functional: true,

  props: {
    name: {
      type: String,
      required: true
    },

    size: {
      type: Number,
      default: 18
    }
  },

  render (h, { props, data }) {
    return h(SHELL_ICONS[props.name], {
      class: ['app-shell-icon', data.staticClass, data.class],
      attrs: { ...data.attrs, 'aria-hidden': 'true' },
      props: { size: props.size, strokeWidth: 1.75 }
    })
  }
}
</script>
